import { Button } from 'antd';
import { SonarCard } from '@ui/general';
import { useNavigate } from 'react-router-dom';
import { VisibleIssuesList } from '../issues';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
export const Issues = () => {
    const navigate = useNavigate();
    const handleOnViewAllIssuesClick = useCallback(() => {
        navigate(FULL_ROUTES.ISSUES);
    }, [navigate]);
    return (React.createElement(SonarCard, { extra: React.createElement(Button, { id: 'view-all-issues-button', onClick: handleOnViewAllIssuesClick }, COPY_SPECIFIC.VIEW_ALL_ISSUES), noSpacing: true, title: COPY_SPECIFIC.VALIDATION_RULE_ISSUES, titleClassName: 'h2' },
        React.createElement(VisibleIssuesList, { hideActions: true, limit: 5 })));
};
